// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, mergeMap } from "rxjs/operators"
import { t } from "@lingui/macro"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { showSnackBar } from "../../snackbar/actions"
import type { Empty } from "@bufbuild/protobuf/wkt"
import {
  NarratePreferencesSchema,
  SetNarratePreferencesRequestSchema,
} from "../../../generated/wisetime/user/assistant/v4/preferences_pb"
import { executorMutation, Init, narratePreferencesService } from "../../../app/rpc"
import { create } from "@bufbuild/protobuf"

type SetNarratePreferencesRpc = (request: Init<typeof SetNarratePreferencesRequestSchema>) => Observable<Empty>

export const setNarratePreferences = (setNarratePreferencesRpc: SetNarratePreferencesRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.setNarratePreferences.match),
      mergeMap(({ payload }) =>
        setNarratePreferencesRpc(payload).pipe(
          mergeMap(() => of(Slice.setSavedNarratePreferences(
            payload.preferences ? create(NarratePreferencesSchema, payload.preferences) : undefined
          ))),
          catchError(_ => of(showSnackBar({
            message: t({
              id: "msg_set_narrate_preferences_failed",
              message: "Failed to save narrate preferences. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )),
    )

const setNarratePreferencesRpc = (request: Init<typeof SetNarratePreferencesRequestSchema>): Observable<Empty> =>
  executorMutation(() => narratePreferencesService.setNarratePreferences(create(SetNarratePreferencesRequestSchema, request)))

export default setNarratePreferences(setNarratePreferencesRpc)
